import {
    CHATGROUP_DATA,
    CHATMETRICS_DATA,
    USERMETRICS_DATA,
    WVMETRICS_DATA,
    GROUPMESSAGE_GET_DATA,
    GROUPMEMBER_DELETE_DATA,
    GROUPMESSAGE_ADD_DATA,
    GROUPMEMBER_ADD_DATA,
    CHAT_IMPORT_DATA,
    CHAT_GROUPAUDIT_DATA,
    CHAT_USERAUDIT_DATA,

} from './Constants'


//For listing auto
const loadChatGroupDataRequest = (grouptype) => ({
    type: CHATGROUP_DATA.CHATGROUP_DATA_LOAD, 
    payload:grouptype,
});
const setChatGroupDataSuccess = (chatgroup) => ({
    type: CHATGROUP_DATA.CHATGROUP_DATA_SUCCESS,
    chatgroup,
});
const setChatGroupDataFail = (error) => ({
    type: CHATGROUP_DATA.CHATGROUP_DATA_FAIL,
    error,
});

// get User metrics
const loadUserMetricsDataRequest = (range) => ({
  type: USERMETRICS_DATA.USERMETRICS_DATA_LOAD,
  payload:range,
});
const setUserMetricsDataSuccess = (user) => ({
  type: USERMETRICS_DATA.USERMETRICS_DATA_SUCCESS,
  user,
});
const setUserMetricsDataFail = (error) => ({
  type: USERMETRICS_DATA.USERMETRICS_DATA_FAIL,
  error,
});

// get chat metrics
const loadChatMetricsDataRequest = (range) => ({
  type: CHATMETRICS_DATA.CHATMETRICS_DATA_LOAD,
  payload:range,
});
const setChatMetricsDataSuccess = (chatmetrics) => ({
  type: CHATMETRICS_DATA.CHATMETRICS_DATA_SUCCESS,
  chatmetrics,
});
const setChatMetricsDataFail = (error) => ({
  type: CHATMETRICS_DATA.CHATMETRICS_DATA_FAIL,
  error,
});

// get WV metrics
const loadWVMetricsDataRequest = (range) => ({
  type: WVMETRICS_DATA.WVMETRICS_DATA_LOAD,
  payload:range,
});
const setWVMetricsDataSuccess = (wvmetrics) => ({
  type: WVMETRICS_DATA.WVMETRICS_DATA_SUCCESS,
  wvmetrics,
});
const setWVMetricsDataFail = (error) => ({
  type: WVMETRICS_DATA.WVMETRICS_DATA_FAIL,
  error,
});

//Get message by chat id
const loadGroupMessageGetDataRequest = (id) => ({
  type: GROUPMESSAGE_GET_DATA.GROUPMESSAGE_GET_DATA_LOAD,
  id,
});
const setGroupMessageGetDataSuccess = (response) => ({
  type: GROUPMESSAGE_GET_DATA.GROUPMESSAGE_GET_DATA_SUCCESS,
  message: response,
});
const setGroupMessageGetDataFail = (error) => ({
  type: GROUPMESSAGE_GET_DATA.GROUPMESSAGE_GET_DATA_FAIL,
  error,
});
// reset message
const clearGroupMessageData = () => ({
  type: GROUPMESSAGE_GET_DATA.GROUPMESSAGE_CLEAR_DATA,
});

// Delete a member from group
const loadGroupMemberDeleteDataRequest = (request) => ({
    type: GROUPMEMBER_DELETE_DATA.GROUPMEMBER_DELETE_DATA_LOAD,
    request,
  });
  const setGroupMemberDeleteDataSuccess = (member) => ({
    type: GROUPMEMBER_DELETE_DATA.GROUPMEMBER_DELETE_DATA_SUCCESS,
    member,
  });
  
  const setGroupMemberDeleteDataFail = (error) => ({
    type: GROUPMEMBER_DELETE_DATA.GROUPMEMBER_DELETE_DATA_FAIL,
    error,
  });
  //For add messages
const loadGroupMessageAddDataRequest = (request) => ({
  type: GROUPMESSAGE_ADD_DATA.GROUPMESSAGE_ADD_DATA_LOAD,
  request,
});
const setGroupMessageAddDataSuccess = (message) => ({
  type: GROUPMESSAGE_ADD_DATA.GROUPMESSAGE_ADD_DATA_SUCCESS,
  message,
});
const setGroupMessageAddDataFail = (error) => ({
  type: GROUPMESSAGE_ADD_DATA.GROUPMESSAGE_ADD_DATA_FAIL,
  error,
});
//For add members
const loadGroupMemberAddDataRequest = (request) => ({
  type: GROUPMEMBER_ADD_DATA.GROUPMEMBER_ADD_DATA_LOAD,
  request,
});
const setGroupMemberAddDataSuccess = (addmembers) => ({
  type: GROUPMEMBER_ADD_DATA.GROUPMEMBER_ADD_DATA_SUCCESS,
  addmembers,
});
const setGroupMemberAddDataFail = (error) => ({
  type: GROUPMEMBER_ADD_DATA.GROUPMEMBER_ADD_DATA_FAIL,
  error,
});
//Import Chat
const loadChatImportDataRequest = (request) => ({
  type: CHAT_IMPORT_DATA.CHAT_IMPORT_DATA_LOAD,
  request,
});

const setChatImportDataSuccess = (company) => ({
  type: CHAT_IMPORT_DATA.CHAT_IMPORT_DATA_SUCCESS,
  company,
});

const setChatImportDataFail = (error) => ({
  type: CHAT_IMPORT_DATA.CHAT_IMPORT_DATA_FAIL,
  error,
});

//Chat Group Audit data
const loadChatGroupAuditDataRequest = (request) => ({
  type: CHAT_GROUPAUDIT_DATA.CHAT_GROUPAUDIT_DATA_LOAD,
  request,
});

const setChatGroupAuditDataSuccess = (groupaudit) => ({
  type: CHAT_GROUPAUDIT_DATA.CHAT_GROUPAUDIT_DATA_SUCCESS,
  groupaudit,
});

const setChatGroupAuditDataFail = (error) => ({
  type: CHAT_GROUPAUDIT_DATA.CHAT_GROUPAUDIT_DATA_FAIL,
  error,
});

//Chat User Audit data
const loadChatUserAuditDataRequest = (request) => ({
  type: CHAT_USERAUDIT_DATA.CHAT_USERAUDIT_DATA_LOAD,
  request,
});

const setChatUserAuditDataSuccess = (useraudit) => ({
  type: CHAT_USERAUDIT_DATA.CHAT_USERAUDIT_DATA_SUCCESS,
  useraudit,
});

const setChatUserAuditDataFail = (error) => ({
  type: CHAT_USERAUDIT_DATA.CHAT_USERAUDIT_DATA_FAIL,
  error,
});




export {
    loadChatGroupDataRequest, setChatGroupDataSuccess, setChatGroupDataFail,
    loadGroupMemberDeleteDataRequest,setGroupMemberDeleteDataFail,setGroupMemberDeleteDataSuccess,
    loadGroupMessageGetDataRequest,setGroupMessageGetDataSuccess,setGroupMessageGetDataFail,
    loadGroupMessageAddDataRequest,setGroupMessageAddDataSuccess,setGroupMessageAddDataFail,
    loadChatMetricsDataRequest,setChatMetricsDataSuccess,setChatMetricsDataFail,
    loadUserMetricsDataRequest,setUserMetricsDataSuccess,setUserMetricsDataFail,
    loadGroupMemberAddDataRequest,setGroupMemberAddDataSuccess,setGroupMemberAddDataFail,
    clearGroupMessageData,
    loadWVMetricsDataRequest,setWVMetricsDataSuccess,setWVMetricsDataFail,
    loadChatImportDataRequest,setChatImportDataSuccess,setChatImportDataFail,
    loadChatGroupAuditDataRequest, setChatGroupAuditDataFail, setChatGroupAuditDataSuccess,
    loadChatUserAuditDataRequest, setChatUserAuditDataFail, setChatUserAuditDataSuccess,
}